import Credit from ".";

export const creditRoutes = () => [
  {
    path: "/admin/credit",
    title: "Credit Management",
    layout: "admin",
    routeType: "admin",
    component: Credit,
  },
]